import React, { Component } from "react";
import {
  Route,
  Link,
  Redirect,
  BrowserRouter as Router,
  withRouter,
  Switch,
} from "react-router-dom";
import { connect } from "react-redux";
import Promise from "bluebird";
import styles from "./App.styles";
import GuestView from "./views/guest/Guest";
import UserView from "./views/user/User";
import * as actions from "./redux/user/actions";
import { getActiveProject } from "./redux/projects";
import { isInitialDataLoaded } from "./redux/app";
import {
  showIncorrectPasswordError,
  showWeakPasswordError,
  showInvalidEmailError,
  showUnavailableEmailError,
  isLoggingIn,
  isLoggedIn,
} from "./redux/user";

import type User from "./models/User";

import "./styles/bootstrap.scss";
import "./styles/app.scss";
import "./styles/custom.scss";

type OwnProps = {};

type LoginCredentialsObject = {
  email: string,
  password: string,
};

type StateProps = {
  showWeakPasswordError: boolean,
  showInvalidEmailError: boolean,
  showIncorrectPasswordError: boolean,
  showUnavailableEmailError: boolean,
  showTouchIdNotSupportedError: boolean,
  user: ?User,
  tempUser: ?User,
  activeTab: TabKey,
  appError: Error,
  isInitialDataLoaded: boolean,
  appLifecycleState: $Keys<typeof APP_LIFECYCLE_STATE>,
  isLoggedIn: boolean,
  isLoggingIn: boolean,
  isAddingUser: boolean,
  isFetchingCollaborators: boolean,
  isCreatingCollaborator: boolean,
  isSettingUpAuth: boolean,
  activeProject: ?Project,
};

type DispatchProps = {
  clearInvalidEmailError: () => void,
  clearIncorrectPasswordError: () => void,
  clearWeakPasswordError: () => void,
  clearUnavailableEmailError: () => void,
  setupAuth: () => Promise<void>,
  logout: () => Promise<void>,
  login: (credentials: LoginCredentialsObject) => Promise<void>,
};

// type Props = OwnProps & StateProps & DispatchProps;

type State = {
  headerTitle: string,
  showHeader: boolean,
  showSidebar: boolean,
  newUserCount: number,
};

const GUEST_SCREENS = {
  LOGIN: "LOGIN",
  USER: "USER",
};

class App extends Component {
  constructor(props) {
    super(props);
  }
  // props: Props;
  state: State = {
    headerTitle: "",
    showHeader: true,
    showSidebar: false,
    newUserCount: 0,
    screen: GUEST_SCREENS.LOGIN,
  };
  loadingPromise: ?Promise<any>;
  loginPromise: ?Promise<any>;
  logoutPromise: ?Promise<any>;
  registrationPromise: ?Promise<any>;

  componentDidMount() {
    this.props.setupAuth();
  }

  componentWillUnmount() {
    this.loadingPromise && this.loadingPromise.cancel();
    this.loginPromise && this.loginPromise.cancel();
    this.logoutPromise && this.logoutPromise.cancel();
    this.registrationPromise && this.registrationPromise.cancel();
  }

  handleLogin = (credentials: LoginCredentialsObject) => {
    this.loginPromise = Promise.resolve(this.props.login(credentials));
  };

  handleLogout = () => {
    this.logoutPromise = Promise.resolve(this.props.logout());
    // Force page refresh so it doesn't cache the projects from the previous account.
    window.location.href = window.location.href;
  };

  handleRegistration = (credentials: RegistrationCredentialsObject) => {
    this.registrationPromise = Promise.resolve(
      this.props.register(credentials)
    );
  };

  showLogin = () => {
    this.setState({
      screen: GUEST_SCREENS.LOGIN,
    });
  };

  renderGuestScreen() {
    switch (this.state.screen) {
      case GUEST_SCREENS.LOGIN:
        return this.loginRoute();
    }
  }

  render() {
    return (
      <div className="app-main">
        <div className="app-container">
          <div style={styles.backgroundColor} className="app-main-container">
            <Switch>
              <Route exact path="/login" component={this.renderGuestView} />
              <Route exact path="/register" component={this.renderGuestView} />
              <Route
                exact
                path="/forgot-password"
                component={this.renderGuestView}
              />
              <Route exact path="/projects" component={this.renderUserView} />
              <Route
                exact
                path="/projects/:id/agenda"
                component={this.renderUserView}
              />
              <Route
                exact
                path="/projects/:id/timeline"
                component={this.renderUserView}
              />
              <Route
                exact
                path="/projects/:id/tasklist"
                component={this.renderUserView}
              />
              <Route exact path="/profile" component={this.renderUserView} />
              <Route
                exact
                path="/subscription"
                component={this.renderUserView}
              />
              <Redirect path="/" to="/login" />
            </Switch>
          </div>
        </div>
      </div>
    );
  }

  renderGuestView = ({ match }) => {
    return (
      <div style={styles.background}>
        <div style={styles.container}>
          <GuestView
            clearInvalidEmailError={this.props.clearInvalidEmailError}
            clearIncorrectPasswordError={this.props.clearIncorrectPasswordError}
            clearWeakPasswordError={this.props.clearWeakPasswordError}
            showInvalidEmailError={this.props.showInvalidEmailError}
            showIncorrectPasswordError={this.props.showIncorrectPasswordError}
            showWeakPasswordError={this.props.showWeakPasswordError}
            showUnavailableEmailError={this.props.showUnavailableEmailError}
            onRequestLogin={this.handleLogin}
            onRequestRegister={this.handleRegistration}
            onRequestSendPasswordResetEmail={this.props.sendPasswordResetEmail}
            isLoggedIn={this.props.isLoggedIn}
            redirectToDash={this.userRoute}
            redirectToLogin={this.loginRoute}
            redirectToRegister={this.registerRoute}
            redirectToForgot={this.forgotRoute}
            path={match.path}
          ></GuestView>
        </div>
      </div>
    );
  };

  renderUserView = ({ match }) => {
    return (
      <UserView
        onRequestLogout={this.handleLogout}
        isLoggedIn={this.props.isLoggedIn}
        redirectToLogin={this.loginRoute}
        redirectToProjects={this.userRoute}
        redirectToAgenda={this.agendaRoute}
        redirectToTimeLine={this.timelineRoute}
        redirectToTaskList={this.taskListRoute}
        path={match.path}
        projectId={match.params.id}
      ></UserView>
    );
  };

  loginRoute = () => {
    this.props.history.push("/login");
  };

  registerRoute = () => {
    this.props.history.push("/register");
  };

  forgotRoute = () => {
    this.props.history.push("/forgot-password");
  };

  userRoute = () => {
    this.props.history.push("/projects");
  };

  agendaRoute = (projectId: Int) => {
    this.props.history.push("/projects/" + projectId + "/agenda");
  };

  timelineRoute = (projectId: Int) =>
    this.props.history.push("/projects/" + projectId + "/timeline");

  taskListRoute = (projectId: Int) =>
    this.props.history.push("/projects/" + projectId + "/tasklist");
}

const mapStateToProps = (state) => {
  return {
    showIncorrectPasswordError: showIncorrectPasswordError(state),
    showWeakPasswordError: showWeakPasswordError(state),
    showInvalidEmailError: showInvalidEmailError(state),
    showUnavailableEmailError: showUnavailableEmailError(state),
    isLoggingIn: isLoggingIn(state),
    isLoggedIn: isLoggedIn(state),
    isInitialDataLoaded: isInitialDataLoaded(state),
    activeProject: getActiveProject(state),
  };
};

export default withRouter(connect(mapStateToProps, actions)(App));



// WEBPACK FOOTER //
// ./src/App.js